import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=693dd02c&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=ts"
export * from "./ContentFooter.vue?vue&type=script&lang=ts"
import style0 from "./ContentFooter.vue?vue&type=style&index=0&id=693dd02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693dd02c",
  null
  
)

export default component.exports